import 'core-js/stable'
import App from './App.vue'
import router from './router'
import store from './store'
import SentryPlugin from '@windsor-telecom/client-core/src/plugins/sentry'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import vuetify from './plugins/vuetify'

// Global mixins
import BaseRenderErrorMixin from '@windsor-telecom/client-core/src/mixins/core/base-render-error.mixin'

Vue.config.productionTip = false
Vue.config.devtools = process.env.VUE_APP_ENV !== 'production'
Vue.mixin(BaseRenderErrorMixin)
Vue.use(VueMeta)

const sentry = process.env.VUE_APP_SENTRY_URL

if (sentry) {
    Vue.use(SentryPlugin(sentry))
}

new Vue({
    router,
    sentry,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
